import React from "react";
import { Button, Col, Form, Row } from "reactstrap";
import StepAcceptTerms from "../Onboarding/StepAcceptTerms";
import Text from "../../components/Text";
import Messages from "../../Shared/Messages";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import userService from "../../services/userService";

class UserOnboardingAcceptTerms extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onUpdateTermsAccepted = (name, value) => {
    this.setState({ [name]: value });
  };

  onSubmit = e => {
    e.preventDefault();
    const { confirmIdentity } = this.props;
    const { termsAccepted } = this.state;

    if (termsAccepted) {
      confirmIdentity();
    } else {
      userService.addOnboardingEvent(
        this.props.inviteCode,
        " User tried to continue without accepting the terms"
      );
      this.setState({
        errorTerms: !termsAccepted
      });
    }
  };

  render() {
    let { termsAccepted, errorTerms } = this.state;

    return (
      <Form onSubmit={this.onSubmit}>
        <h3 className="text-center mb-3 font-sm-size">
          <Text content={Messages.accept_tc} />
        </h3>

        <div>
          <StepAcceptTerms
            onUpdateData={this.onUpdateTermsAccepted}
            facilityInfo={this.props.facilityInfo}
            termsAccepted={termsAccepted}
            errorTerms={errorTerms}
          />

          <ReactCSSTransitionGroup
            transitionName="example"
            transitionEnterTimeout={1000}
            transitionLeaveTimeout={500}
          >
            {errorTerms && (
              <p className="text-muted">
                <span style={{ color: "red" }}>
                  <Text content={Messages.accept_pp_tc} />
                </span>
              </p>
            )}
          </ReactCSSTransitionGroup>
        </div>

        <Row>
          <Col xs="12">
            <div className="text-right">
              <Button color="primary" size="lg" className="px-4" block>
                <Text content={Messages.sh_submit} />
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default UserOnboardingAcceptTerms;
